import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns';

export default function Detail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContactDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log('API 요청 시작:', `/api/admin/contact_d/${id}`);

        const response = await axios.get(`/api/admin/contact_d/${id}`);
        console.log('API 응답:', response.data);

        if (response.data && response.data.success !== false) {
          const data = response.data.data;
          setContactData(data);
          console.log('데이터 설정됨:', data);
        } else {
          console.error('API 응답 오류:', response.data);
          setError(response.data.error || '정보를 불러오는데 실패했습니다.');
        }
      } catch (error) {
        console.error('API 요청 실패:', error);

        let errorMessage = '데이터를 불러오는 중 오류가 발생했습니다.';

        if (error.response) {
          console.error('응답 상태:', error.response.status);
          console.error('응답 데이터:', error.response.data);
          errorMessage = `서버 오류 (${error.response.status}): ${
            error.response.data.message || error.response.statusText
          }`;
        } else if (error.request) {
          console.error('요청 정보:', error.request);
          errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
        } else {
          console.error('오류 메시지:', error.message);
          errorMessage = `요청 오류: ${error.message}`;
        }

        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchContactDetail();
    }
  }, [id]);

  // 카테고리 텍스트 반환
  const getCategoryText = (category) => {
    return category === 0 ? '제휴문의' : '고객센터(문의)';
  };

  // 지역 텍스트 반환
  const getRegionText = (regionCode) => {
    const regionMap = {
      'seoul': '서울',
      'gyeonggi': '경기',
      'incheon': '인천',
      'gangwon': '강원',
      'chungcheong': '충청',
      'jeolla': '전라',
      'gyeongsang': '경상',
      'jeju': '제주'
    };
    return regionMap[regionCode] || regionCode || '-';
  };

  // 로봇 유형 텍스트 반환
  const getRobotTypeText = (robotType) => {
    const robotTypeMap = {
      'serving': '서빙로봇',
      'logistics': '물류로봇',
      'cleaning': '청소로봇'
    };
    return robotTypeMap[robotType] || robotType || '-';
  };

  // 날짜 포맷팅
  const formatDate = (dateString) => {
    if (!dateString) return '-';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      return format(date, 'yyyy-MM-dd HH:mm');
    } catch (error) {
      console.error('날짜 포맷팅 오류:', error);
      return dateString;
    }
  };

  const handleGoToList = () => {
    navigate('/admin/contact');
  };

  if (loading) {
    return (
      <div className="content-wrapper">
        <div className="titleNav">문의 상세</div>
        <div className="wrap">
          <div
            className="over_hi"
            style={{ marginTop: '60px', textAlign: 'center' }}
          >
            <p>로딩 중...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-wrapper">
        <div className="titleNav">문의 상세</div>
        <div className="wrap">
          <div
            className="over_hi"
            style={{ marginTop: '60px', textAlign: 'center' }}
          >
            <p style={{ color: 'red' }}>{error}</p>
            <button
              type="button"
              className="common-del"
              onClick={handleGoToList}
            >
              목록으로
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!contactData) {
    return (
      <div className="content-wrapper">
        <div className="titleNav">문의 상세</div>
        <div className="wrap">
          <div
            className="over_hi"
            style={{ marginTop: '60px', textAlign: 'center' }}
          >
            <p>문의를 찾을 수 없습니다.</p>
            <button
              type="button"
              className="common-del"
              onClick={handleGoToList}
            >
              목록으로
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="content-wrapper">
        <div className="titleNav">문의 상세</div>
        {/* content S */}
        <div className="">
          <div className="over_hi" style={{ marginTop: '60px' }}>
            <table className="adminTable">
              <tbody>
                <tr>
                  <th style={{ width: '200px' }}>카테고리</th>
                  <td className="left">
                    <p>{getCategoryText(contactData?.c_category1)}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>회사명</th>
                  <td className="left">
                    <p>{contactData?.c_company_name || '-'}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>담당자명</th>
                  <td className="left">
                    <p>{contactData?.c_name || '-'}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>전화번호</th>
                  <td className="left">
                    <p>{contactData?.c_tel || '-'}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>이메일</th>
                  <td className="left">
                    <p>{contactData?.c_email || '-'}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>제목</th>
                  <td className="left">
                    <p>{contactData?.c_title || '문의 제목'}</p>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>내용</th>
                  <td className="left">
                    <div
                      style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}
                    >
                      {contactData?.c_content || '-'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>지역/주소</th>
                  <td className="left">
                    <p>{getRegionText(contactData?.c_addr1)}</p>
                    {contactData?.c_addr2 && (
                      <p style={{ marginTop: '5px', color: '#666' }}>
                        상세주소: {contactData.c_addr2}
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '200px' }}>문의항목</th>
                  <td className="left">
                    <div>
                      {contactData?.c_prd && (
                        <p>
                          <strong>로봇 유형:</strong> {getRobotTypeText(contactData.c_prd)}
                        </p>
                      )}
                      {contactData?.c_prdname && (
                        <p style={{ marginTop: '5px' }}>
                          <strong>로봇 모델:</strong> {contactData.c_prdname}
                        </p>
                      )}
                      {!contactData?.c_prd && !contactData?.c_prdname && (
                        <p>-</p>
                      )}
                    </div>
                  </td>
                </tr>
         
                <tr>
                  <th style={{ width: '200px' }}>등록일시</th>
                  <td className="left">
                    <p>{formatDate(contactData?.c_add_dt)}</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="right">
              <input
                type="button"
                value="목록으로"
                className="common-del"
                onClick={handleGoToList}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}